var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelemedicinaNav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.00005 17.0003H23V3.2503H3.00005V17.0003ZM14.25 19.5003V22.0003H19.25V24.5003H6.75005V22.0003H11.7501V19.5003H1.74005C1.57591 19.4993 1.41357 19.466 1.26235 19.4021C1.11112 19.3383 0.973984 19.2452 0.85879 19.1283C0.743596 19.0114 0.652611 18.8728 0.591052 18.7207C0.529492 18.5685 0.498568 18.4057 0.500051 18.2416V2.00906C0.500051 1.31406 1.0688 0.750305 1.74005 0.750305H24.26C24.945 0.750305 25.5 1.31156 25.5 2.00906V18.2416C25.5 18.9366 24.9313 19.5003 24.26 19.5003H14.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelemedicinaNav);
export default __webpack_public_path__ + "static/media/telemedicinaNav.1ec74898b2b8502c32996f4a392a90e0.svg";
export { ForwardRef as ReactComponent };